import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-size-24 mt-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-6" }, null, -1)
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_RadioGroup = _resolveComponent("RadioGroup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('goOutSetting')), 1),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('managementOfOutingTime')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.managementOfOutingTimeList,
        modelValue: _ctx.workingStyleMasterParams.is_using_go_out_check_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workingStyleMasterParams.is_using_go_out_check_time = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('handlingOfOutingTime')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.handlingOfOutingTimeList,
        modelValue: _ctx.workingStyleMasterParams.is_minus_go_out_time_in_working_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.workingStyleMasterParams.is_minus_go_out_time_in_working_time = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ])
  ], 64))
}